// src/utils/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCvI0fzaBID1B3H6Sh57l9PxoyPnm90Gbw",
  authDomain: "namsanbro.com",
  projectId: "namsan-bro",
  storageBucket: "namsan-bro.firebasestorage.app",
  messagingSenderId: "54552252649",
  appId: "1:54552252649:web:6033603711fc0411fae078",
  measurementId: "G-7TK1D0FHBP"
};

const app = initializeApp(firebaseConfig);

// 🔥 namsan 데이터베이스 사용
export const db = getFirestore(app, 'namsan');
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);


